export const API_URL =
  process.env.REACT_APP_API_URL || "https://localhost:5002/v2";
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || "https://localhost:5002/";
export const JWT_SECRET = "fi8bfk3ikfuk3urf93uf3uh3fuh";
